<template>
  <div>
    

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 150px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in getButtons(selectedRow)" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :value="versions"
      :paginator="true"
      dataKey="customerId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedContacts"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Versions"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
      :style="{ 'width': '100%' }"
      :resizableColumns="true" 
      columnResizeMode="expand"
    >
      <template #empty> No versions found. </template>
      <template #loading> Loading versions data. Please wait. </template>
      <!-- <Column selectionMode="multiple" headerStyle="width: 3em;"></Column> -->
      <Column 
        header="Actions"
        headerStyle="width: 50px; padding: 7.5px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            <Button 
              icon="pi pi-ellipsis-h" 
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column
        field="version"
        header="Quote/Version"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.quoteVer }}
          </div>
        </template>
      </Column>
      <Column
        field="versionDate"
        header="Version Date"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.quoteVerDate }}
          </div>
        </template>
      </Column>
      <Column
        field="fullName"
        header="Created By"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.createdBy  ? slotProps.data.createdBy.fullName : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="productValue"
        header="Value"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            {{ slotProps.data.productValue }}
          </div>
        </template>
      </Column>
      <Column
        field="statusName"
        header="Status"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div  
            style="height: 26px; display: flex; align-items: center;"
          >
            <span 
              v-on:click="changeStatus(slotProps.data)"
              :class="'ignore pointer badge ' + getStyle(slotProps.data.quoteStatus)" 
            >
              {{ slotProps.data.quoteStatus && slotProps.data.quoteStatus.statusName ? slotProps.data.quoteStatus.statusName : '' }}
            </span>
              
            <OverlayPanel 
              ref="statuses" 
              appendTo="body" 
              :showCloseIcon="true" 
              id="statuses" 
              style="width: 120px"
            > 
              <div
                v-for="(val, index) in quoteStatuses"
                :key="index"
              >
                <span 
                  @click="updateStatus(val)" 
                  :class="'ignore pointer badge ' + getStyle(val)" 
                >
                  {{ val.statusName }}
                </span>
                <br />
                <br />
              </div>
            </OverlayPanel>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";

import {
  quotationRequest
} from '../../universalComponents/sendRequest'

export default {
  props: [
    'versions', 
    'filters',
    'loading'
  ],
  data() {
    return {
      quotationService: new QuotationService(),
      selectedContacts: null,
      quotation: {},
      selectedCustomer: {},
      productType: {},
      quoteStatuses: [],
      sendingRequest: false,
      selectedRow: null
    }
  },
  computed: {
    myPermissions() {
      return this.$store.getters['auth/getUserPermissions']
    },
  },
  created() {
    this.quotationService
      .getAllActiveQuotationStatuses()
      .then(data => this.quoteStatuses = data)
      .catch(err => {
        
              
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting quotation statuses",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activeQuoteStatuses"'
        })
      })
  },
  methods: {
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    getButtons(data) { 
      let buttons = []
      buttons.push(
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.deleteVersion(data)
          }
        }
      )
      return buttons
    },
    updateStatus(val) {
      if (this.quotation && this.quotation.quoteVerId && val.id) {
        this.quotation.quoteStatus = val
        this.selectedCustomer = {...this.quotation.customer}
        this.productType = {...this.quotation.productType}
        
        this.sendingRequest = true
        quotationRequest(this, 'versionsTable.vue')
      }
    },
    changeStatus(quotation) {
      this.quotation = {...quotation}
      this.$refs.statuses.toggle(event);
    },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.colourCode) {
        return data.colourCode
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'lost') {
        return 'badge-danger'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'active') {
        return 'badge-primary'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'won') {
        return 'badge-success'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'cancelled') {
        return 'badge-warning'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'revised') {
        return 'badge-secondary'
      } else {
        return 'badge-dark'
      }
    },
    deleteVersion(version) {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteQuotation');
        if (permission) {
          if (permission.permissionLevel !== 0) {
            // only then you can do the deletion
          } else {
              this.$toast.add({
                severity: "error",
                summary: "Not allowed",
                detail: "You are not allowed to delete a Quotation",
                life: 5000,
              })
          }
        }
    },
    editVersion(version) {
      
      this.$emit('editQuote', version)
    }
  }
}
</script>

<style scoped lang="scss">

</style>